require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./bike-theft-reduction.json") })
        }
      }, "path---bike-theft-reduction");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---bike-theft-reduction!./.cache/json/bike-theft-reduction.json
// module id = 846
// module chunks = 231608221292675